import React from 'react';

const FBNDeviceCard = ({ data, onClick }) => {
    const device_type = data?.device_type || {};

  return (
    <div className="container my-4 pb-5">
          <div className="card shadow rounded-4 py-4">
            <h5 className="fw-bold text-center my-5">{device_type?.device_name}</h5>
    
            {/* Device Image + Specs Section with Shadow */}
            <div className="row mb-2 px-2">
              <div className="col-md-11 mx-auto">
                <div className="card shadow-lg rounded-4 p-3 mb-4 ">
                  <div className="row px-2">
                    {/* Device Image */}
                    <div className="col-md-6 d-flex justify-content-center align-items-center mb-5">
                      <img
                        src={device_type?.main_photo}
                        alt={device_type?.device_name}
                        className="img-fluid rounded"
                        style={{ height: "300px", width: "100%", objectFit: "contain" }}
                      />
                    </div>
    
                    {/* Device Specs */}
                    <div className="col-md-5">
                      <ul
                        style={{
                          listStyleType: '"✔ "',
                          paddingLeft: "0.2rem",
                          fontSize: "16px",
                        }}
                      >
                        <li className="py-2">
                          <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                            Data Quantity:
                          </strong>{" "}
                          {device_type?.data_qty}
                        </li>
                          <li className="py-2">
                            <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                              Voice Minutes:
                            </strong>{" "}
                            {device_type?.voice_mins} mins
                          </li>
                        {Number(device_type?.sms_qty) > 0 && (
                          <li className="py-2">
                            <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                              SMS Quantity:
                            </strong>{" "}
                            {device_type?.sms_qty}
                          </li>
                        )}
                        <li className="py-2">
                          <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                            Screen Replacement:
                          </strong>{" "}
                          {device_type?.screen_replacement}
                        </li>
                          <li className="py-2">
                            <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                              Phone Replacement:
                            </strong>{" "}
                            {device_type?.phone_replacement}
                          </li>
                        
                        <li className="py-2">
                          <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                            Custom Lock:
                          </strong>{" "}
                          {device_type?.custom_lock}
                        </li>
                        <li className="py-2">
                          <strong style={{ fontSize: "15px", fontWeight: "bold" }}>
                            Warranty Coverage:
                          </strong>{" "}
                          {device_type?.warranty_coverage}
                        </li>
                      </ul>
    
                      <p
                        style={{
                          fontSize: "14px",
                          fontStyle: "italic",
                          color: "#555",
                          marginTop: "10px",
                        }}
                      >
                        • <strong>RAM:</strong> {device_type?.device_ram} &nbsp; •{" "}
                        <strong>Storage:</strong> {device_type?.storage} &nbsp; •{" "}
                        <strong>Battery:</strong> {device_type?.battery}
                      </p>
                    </div>
    
                  </div>
                </div>
              </div>
            </div>
            {/* Select Deviece Button */}
            <div className="mt-3 px-3 d-flex justify-content-center">
                <button
                className="btn btn-primary"
                onClick={() => onClick(device_type?.id)}
                >
                    Select Device
                </button>
            </div>
          </div>
        </div>
  )
}

export default FBNDeviceCard;